import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PaymentMethodDto } from '@well/company-libs/payment-method/domain-model';
import { FormGroup, FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { SharedComponentsModule } from '@irian-ro/shared-components-module';
import { FormUtils } from '@irian-ro/util-forms';
import { RouterLink } from '@angular/router';
import { FormInlineErrorDirective } from '@irian-ro/shared-ui';
import { RadioButton, RadioButtonModule } from 'primeng/radiobutton';
@Component({
  selector: 'well-payment-method-inputs',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    RadioButtonModule,
    ButtonModule,
    CheckboxModule,
    SharedComponentsModule,
    RouterLink,
    FormInlineErrorDirective
    ],
  templateUrl: './payment-method-inputs.component.html',
  styleUrls: ['./payment-method-inputs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentMethodInputsComponent {
  translate = inject(TranslateService);
  @Input() model: PaymentMethodDto = new PaymentMethodDto();
  @Input() showTermsAndConditions = false;

  termsAndConditions = false;
  @Input() methods: string[] | null = null;
  @Output() save: EventEmitter<PaymentMethodDto> = new EventEmitter<PaymentMethodDto>();
  submit(form: FormGroup) {
    FormUtils.markAllAsDirty(form);
    FormUtils.markAllAsTouched(form);
    if (form.valid) {
      this.save.emit(this.model);
    }
  }
}
